import { Button, Container } from '@mui/material'
import React, { Fragment, useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import Cookies from 'universal-cookie'
import { AppLogo } from '../../utility/SVGUtility'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule'
import { useParams } from 'react-router-dom'
import { getAppDetails } from '../../services/AppDetailsService'
import { getAllApps } from '../../services/MarketplaceService'
import { SUCCESS } from '../../constants/Constants'
import RelatedApps from '../details/RelatedApps'
import Spinner from '../../utility/Spinner'
import { AppDataList } from '../home/HomePage'
import { BaseUrl as getBlobBaseUrl } from '../../utility/BaseUrl'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import Slide from '@mui/material/Slide'
import { TransitionProps } from '@mui/material/transitions'
import Contact from '../contact/Contact'
import Icon from '@mui/icons-material/Info'
import { AppContext } from '../../App'
import DOMPurify from 'dompurify'
import ReactGA from 'react-ga4'
import { isValidJson } from '../../utility/Utility'
import NotFound from '../../views/NotFound'
import { CommonColorCodes } from '../../utility/CommonColorCodes'
import { IconWrapper as IWrapper } from '../../css/Style'

const Transition = React.forwardRef(function Transition (
  props: TransitionProps & {
    children: React.ReactElement<unknown, string>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />
})

const SpinCoords = styled.div`
  margin: auto;
`

const TitlePanel = styled.div`
  min-height: 156px;
  padding-top: 48px;
  font-family: 'AeonikPro-Regular';
  display: flex;
  flex-wrap: wrap;
  & > svg {
    margin-right: 24px;
  }
  @media (min-width: 0px) and (max-width: 600px) {
    padding-top: 17px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 38px;
  }
  @media (min-width: 601px) and (max-width: 900px) {
    align-items: center;
  }
`

const Summary = styled.div`
  display: flex;
  flex-direction: column;
`

const Title = styled.div`
  font-family: 'AeonikPro-Medium';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 36px;
  color: #35324A;
  @media (min-width: 0px) and (max-width: 600px) {
           font-size: 16px;
           line-height: 24px;
           text-align: center;
           margin-top: 17px;
  }
`

const Publisher = styled.div`
    font-family: 'AeonikPro-Regular';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 26px;
    color: #35324A;
    margin-top: 8px;
    @media (min-width: 0px) and (max-width: 600px) {
        font-size: 14px;
        line-height: 20px;
        text-align: center;
    }
`

const UseCasePanel = styled.div`
    display: block;
    margin-top: 15px;
    max-height: 32px;
    display: flex;
    align-items: center;
    @media (min-width: 0px) and (max-width: 600px) {
        flex-direction: column;
        max-height: fit-content;
    }
`

const UseCase = styled.div`
  font-family: 'AeonikPro-Medium';
  font-weight: 500;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  line-height: 24px;
  color: #EA5834;
  margin-right: 5px;
  @media (min-width: 0px) and (max-width: 600px) {
    font-size: 12px;
    line-height: 16px;
    white-space: nowrap;
  }
`

const Download = styled.div`
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
  margin-left: 16px;
  font-size: 16px;
  line-height: 24px;
  @media (min-width: 0px) and (max-width: 600px) {
    margin-top: 4px;
    margin-left: 0px;
  }
`

const DemoDiv = styled.div`
  margin: 25px 0px 0px auto;
  @media (min-width: 601px) and (max-width: 900px){
        display: block;
    width: 100%;
    margin: 48px 56px 30px 56px;
  } 
  @media (min-width: 0px) and (max-width: 600px){
    width: 100%;
  }

`
const icontStyle = {
  height: '16.7px',
  width: '16.7px',
  margin: '1px 3px 0px'

}
const InfoDiv = styled.div`
  display: flex;
  flex-direction: row;
  height: 24px;
  margin-top: 12px;
  font-style: italic;
  font-size: 16px;
  font-weight: 400;
  color: rgba(36, 32, 59, 0.7);
  line-height: 24px;
  font-family: 'Helvetica Neue';
  justify-content: center;
`

const DemoButton = styled(Button)({
  height: '52px',
  width: '228px',
  background: '#FF6B18',
  borderRadius: '4px',
  textTransform: 'none',
  boxShadow: 'none',
  fontFamily: 'AeonikPro-Regular',
  fontSize: '16px',
  lineHeight: '15.2px',
  fontWeight: '400',
  '&:hover': {
    background: '#FF6B18',
    boxShadow: 'none'
  },
  '&:active': {
    boxShadow: 'none',
    background: '#FF6B18'
  },
  '@media only screen and (max-width: 900px)': {
    width: '100%'
  }
})

const Gallery = styled.div`
  height: fit-content;
  width: 100%;
  overflow: hidden;
  margin: 32px 0px;
  display: flex;
  flex-direction: row;
  overflow: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  padding: 5px 0px;
  &::-webkit-scrollbar {
    display: none;
  }
  @media (min-width: 0px) and (max-width: 420px) {
         flex-direction: column;
         max-height: 600px;
         margin: 0px;
          overflow-x: hidden;
              -ms-overflow-style-x: hidden;
         overflow-y: none;
         -ms-overflow-style-y: none;
  }
`

const ImageContent = styled.img`
  width: 366px;
  height: 233px;
  margin-right: 20px;
  cursor: pointer;
  -webkit-user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  &::selection {
    border: 1px solid #ddd;
  }
  @media (min-width: 0px) and (max-width: 420px) {
         margin-bottom: 16px;
         width: 100%;
  }
`

const VideoContent = styled.iframe`
  margin-right: 20px;
`

const OverviewPanel = styled.div`
  font-family: 'AeonikPro-Regular';
  display: flex;
  flex-wrap: wrap;
  @media only screen and (max-width: 600px) {
    margin: auto;
  }
`

const OvervieAndWhatsNew = styled.div`
  font-family: inherit;
  min-height: 100%;

  @media (min-width: 601px)   and (max-width: 1000px) {
    border-right: 1px solid lightgray;
    padding-right: 36px;
    margin-right: 50px;
    width: 54%;
  }
  @media (min-width: 1001px)  {
    margin-top: 10px;
    border-right: 1px solid lightgray;
    padding-right: 36px;
    margin-right: 50px;
    width: 60%;
  }
  
  @media (min-width: 0px)  and (max-width: 650px) {
    width: 100%;
    margin: 0px auto;
  }
  @media (min-width: 1350px){
    width: 805px;
    margin: 19px 48px 0px 0px
  } 
`

const HTMLRender = styled.div`
  margin: 10px 0px;
  font-family: 'AeonikPro-Regular';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #35324A;
  @media only screen and (max-width: 360px) {
    margin: 10px 0 0 0;
  }
`

const AdditionalInfo = styled.div`
  min-height: 100%;
  width: 30%;
  margin-top: 19px;
  @media only screen and (max-width: 650px) {
    width: 100%;
    margin: 0px auto;
  }
  @media (min-width: 651px) and (max-width: 900px) {
    width: 30%;
    margin: 0px auto;
  }
  @media (min-width: 1350px){
    width: 308px;
  } 

`

const Heading = styled.div`
  font-family: 'AeonikPro-Medium';
  font-style: normal;
  font-weight: 500;
  font-size: 30px;
  line-height: 45px;
  color: #35324A;
  margin: 20px 0px 12px 0px;
  @media only screen and (max-width: 900px) {
       margin: 0px 0px 16px 0px;
       font-size: 24px;
        line-height: 36px;
  }
  
`

const SubHeading = styled.div`
  font-family: 'AeonikPro-Medium';
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #24203B;
  margin-top: 20px;
`

const SubText = styled.div`
  font-family: inherit;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: ${CommonColorCodes.INK_300};
  margin-top: 4px;
`

const IconWrapper = styled(IWrapper)`
  width:120px;
  height:120px;
  margin-right: 36px;
  
`
const MainContainer = styled.div`
  @media (min-width: 901px) and (max-width: 1200px) {
    background: #25233B;
    padding: 0% 5%;
  }
  @media (min-width: 1201px) {
    background: #25233B;
  }
`
const PriceStyle = styled.span`
  margin-left: '5.6px'
  font-family: 'Aeonik Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
`

const SpinnerDiv = styled.div`
  width: 100%;
  height: 100vh;
  display: inline-flex;
`

export const appDetails = {
  name: '',
  icon: '',
  publisherEntName: '',
  price: 100,
  version: '',
  useCaseList: [],
  categoryList: [],
  applicationList: [],
  last_updated: '',
  languages: [],
  description: '',
  downloads: 0,
  media: [],
  gallary: [{ type: '', url: '' }],
  overview: '',
  release_notes: '',
  related: [],
  usecase: '',
  businessImpact: ''
}

const AppDetails = () => {
  const { currentApp } = useContext(AppContext)
  const [appData, setAppData] = useState(appDetails)
  const [isLoading, setIsLoading] = useState(true)
  const { appId } = useParams()
  const [open, setOpen] = useState(false)
  const [relatedApps, setRelatedApps] = useState<AppDataList[]>()
  const [showErr, setShowErr] = useState(false)
  const [disableDemo, setDisableDemo] = useState(false)
  const [appDetailsLoad, setAppDetailsLoad] = useState(false)
  const [appLoad, setAppLoad] = useState(false)
  const cookies = new Cookies()

  const PROVIDER = 'Whatfix'
  const DEMO_REQUEST = 'Request a Demo'
  const DEMO_REQUESTED = 'Requested'

  const showDownloads = false

  const constainerStyles = {
    background: 'white',
    borderRadius: '20px',
    marginTop: '36px',
    '@media (min-width: 1350px)': {
      width: '1296px',
      maxWidth: '1296px',
      height: isLoading ? '100vh' : 'auto',
      margin: 'auto',
      justifyContent: 'center',
      paddingLeft: '48px',
      paddingRight: '48px',
      marginTop: '36px'
    },
    '@media (min-width: 451px) and (max-width: 900px)': {
      marginTop: '0px'
    }
  }

  useEffect(() => {
    setAppLoad(false)
    setAppDetailsLoad(false)
    setIsLoading(true)
    getAppDetails(appId, getAppData)
    getAllApps(getAllAppData, '')
    window.scrollTo(0, 0)
    if (appId && cookies.get(appId)) {
      setDisableDemo(true)
    }
  }, [appId])

  useEffect(() => {
    if (appLoad && appDetailsLoad) {
      setIsLoading(false)
    }
  }, [appLoad, appDetailsLoad])

  const onButtonClick = () => {
    setOpen(true)
  }

  const getAppData = (response: typeof appDetails, status: string) => {
    if (status === SUCCESS) {
      setAppData(response)
      document.title = response.name ? response.name : 'Marketplace'
      ReactGA.event({
        category: 'App Details',
        action: 'App Details',
        label: response.name
      })
      setAppDetailsLoad(true)
    } else {
      setShowErr(true)
    }
  }

  const getAllAppData = (response: AppDataList[], status: string) => {
    if (response && status === SUCCESS && response.length > 0) {
      response = response.filter(res => res.appId !== currentApp)
      setRelatedApps(response.slice(0, 3))
      setAppLoad(true)
    }
  }

  const getAppIcon = (icon: string) => {
    if (icon) {
      icon = icon && isValidJson(icon) ? JSON.parse(icon).path : icon
      return <IconWrapper src= {`https://${getBlobBaseUrl()}${icon}`} />
    }
    return <AppLogo />
  }

  const getAppGallaryContent = (link: string, index: number) => {
    const fileObject = link && isValidJson(link) ? JSON.parse(link) : link
    if (fileObject.type && fileObject.type.indexOf('video') > -1) {
      return (
        <VideoContent
          key={'vc_' + index}
          src={`https://${getBlobBaseUrl()}${fileObject.path}`}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      )
    } else {
      const path = isValidJson(link) ? fileObject.path : link
      return (
        <Zoom zoomMargin={100}>
          <ImageContent
            key={'ic_' + index}
            src={`https://${getBlobBaseUrl()}${path}`}
          />
        </Zoom>
      )
    }
  }

  const handleClose = () => {
    setOpen(false)
    if (appId && cookies.get(appId)) {
      setDisableDemo(true)
    }
  }

  return (
    <Fragment>
      { showErr && <NotFound />}
      <MainContainer>
      <Container sx={constainerStyles}>
      {isLoading &&
      <SpinnerDiv>
        <SpinCoords><Spinner /></SpinCoords>
      </SpinnerDiv>}

        {!isLoading && appData && appData.name && <>
          <TitlePanel>
            {getAppIcon(appData.icon)}
            <Summary>
              <Title>{appData.name}</Title>
              <Publisher>By {PROVIDER}</Publisher>
              <UseCasePanel>
              {appData.useCaseList.map((item, index) => (<UseCase key = {'uc_' + index}>{item}
               {index !== appData.useCaseList.length - 1 ? ',' : ''} </UseCase>))}
               {showDownloads && <Fragment>
                 <HorizontalRuleIcon sx={[{ transform: 'rotate(90deg)', color: `${CommonColorCodes.INK_300}` },
                   () => ({
                     '@media (min-width: 0px) and (max-width: 900px)': { display: 'none' }
                   })
                 ]} fontSize='large' color='action'/>
                <Download>
                    <FileDownloadOutlinedIcon fontSize='medium' color='action'/>
                    <span style={{ marginLeft: '10px' }}> {appData.downloads} downloads </span>
                </Download>
                </Fragment>}
              </UseCasePanel>
            </Summary>
            <DemoDiv >
              <DemoButton variant="contained" size='large' onClick={onButtonClick}>
                {disableDemo ? DEMO_REQUESTED : DEMO_REQUEST}
              </DemoButton>

              {showDownloads && <InfoDiv>
                <Icon sx={icontStyle}> info </Icon>
                <PriceStyle> Payment needed for full version </PriceStyle>
              </InfoDiv>}
            </DemoDiv>
          </TitlePanel>
          {appData.media && appData.media.length > 0 && <Fragment>
          <Heading>Preview</Heading>
          <Gallery>
                {appData.media && appData.media.map((link, index) => getAppGallaryContent(link, index))}
          </Gallery>
          </Fragment>}
          <OverviewPanel >
            <OvervieAndWhatsNew>
              <Heading>Overview</Heading>
              <HTMLRender dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(appData.overview) }} />
              {appData.release_notes && <Heading> What&apos;s New</Heading>}
              <HTMLRender dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(appData.release_notes) }} />
              {appData.usecase && <Heading style={{ fontSize: '20px' }}>Examples of how to use this app</Heading>}
              <HTMLRender dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(appData.usecase) }} />
              {appData.businessImpact && <Heading style={{ fontSize: '20px' }}>Business Impact</Heading>}
              <HTMLRender dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(appData.businessImpact) }} />
            </OvervieAndWhatsNew>
            <AdditionalInfo>
              <Heading>Additional Info</Heading>
              <SubHeading>Version</SubHeading>
              <SubText>{appData.version}</SubText>
              {appData.last_updated && <SubHeading>Last Updated</SubHeading>}
              <SubText>{appData.last_updated}</SubText>
              {appData.languages && appData.languages.length > 0 && <SubHeading>Language</SubHeading>}
              <SubText>{appData.languages && appData.languages.join(', ')}</SubText>
              <SubHeading>Provider</SubHeading>
              <SubText>{ PROVIDER}</SubText>
              <SubHeading>Application</SubHeading>
              <SubText>{appData.applicationList && appData.applicationList.join(', ')}</SubText>
            </AdditionalInfo>
          </OverviewPanel>
          <RelatedApps isSearch = {false} apps={relatedApps} />
          </>
          }

      </Container>
      <div>

        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogContent>
            <Contact appId = {appId} open ={open} handleClose ={handleClose} appName={appData.name}></Contact>
          </DialogContent>
        </Dialog>
      </div>
      </MainContainer>
    </Fragment>
  )
}

export default AppDetails
